"use strict";import{tag as l}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const Checkmark300Icon=({width:e=24,height:t=24,hidden:a=!1,title:r="Checkmark300"}={})=>l`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    aria-hidden=${a?"true":"false"}
    role="img"
    fill="currentColor"
    aria-label="${r}"
    width="${e}"
    height="${t}"
  >
    <path
      d="M5.102 12.514a1.09 1.09 0 0 1-.834-.39L.988 8.19A1.085 1.085 0 0 1 2.656 6.8l2.421 2.906 6.243-7.947a1.085 1.085 0 0 1 1.707 1.34L5.955 12.1a1.09 1.09 0 0 1-.838.415z"
    />
  </svg>`;
//# sourceMappingURL=Checkmark300.js.map
